if (!customElements.get('pomodoro-controller-v2')) {
  class PomodoroControllerV2 extends HTMLElement {
    connectedCallback() {
      const root = this.closest('[data-pomodoro]');
      if (!root) return;
      this.abort = new AbortController();
      const listen = (el, event, fn) => el?.addEventListener(event, fn, { signal: this.abort.signal });
      const labels = JSON.parse(root.querySelector('[data-pm-labels]').textContent);
      const quantity = root.querySelector('.pm-quantity input[name="quantity"]');
      const dialog = root.querySelector('.pm-lightbox');
      const setQuantity = value => {
        const parsed = Number(value);
        const next = Number.isSafeInteger(parsed) && parsed >= 1 ? parsed : 1;
        quantity.value = String(next);
        root.querySelectorAll('[data-offer]').forEach(row => {
          const selected = Number(row.dataset.offer) === next;
          row.dataset.selected = String(selected);
          const button = row.querySelector('[data-select-pack]');
          button.setAttribute('aria-pressed', String(selected));
          button.textContent = selected ? labels.selected : labels.choose;
        });
      };
      root.querySelectorAll('[data-thumb]').forEach(button => listen(button, 'click', () => {
        root.querySelectorAll('[data-slide]').forEach(slide => slide.hidden = slide.dataset.slide !== button.dataset.thumb);
        root.querySelectorAll('[data-thumb]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
      }));
      const openZoom = () => {
        const current = root.querySelector('[data-slide]:not([hidden])');
        if (!current || !dialog) return;
        const img = document.createElement('img');
        img.src = current.href;
        img.alt = current.querySelector('img')?.alt || '';
        dialog.querySelector('[data-zoom-image]').replaceChildren(img);
        dialog.showModal();
      };
      root.querySelectorAll('[data-zoom]').forEach(link => listen(link, 'click', event => { event.preventDefault(); openZoom(); }));
      listen(root.querySelector('[data-open-zoom]'), 'click', openZoom);
      listen(root.querySelector('[data-close-zoom]'), 'click', () => dialog.close());
      listen(dialog, 'click', event => { if (event.target === dialog) dialog.close(); });
      root.querySelectorAll('[data-select-pack]').forEach(button => listen(button, 'click', () => setQuantity(button.dataset.selectPack)));
      root.querySelectorAll('[data-quantity-step]').forEach(button => listen(button, 'click', () => setQuantity(Number(quantity.value) + Number(button.dataset.quantityStep))));
      listen(quantity, 'change', () => setQuantity(quantity.value));
      const format = cents => {
        if (root.dataset.currency === 'TRY') return new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 2 }).format(cents / 100) + ' TL';
        return new Intl.NumberFormat(root.dataset.locale || 'en', { style: 'currency', currency: root.dataset.currency }).format(cents / 100);
      };
      const select = root.querySelector('select[name="id"]');
      const syncPackage = () => {
        if (!select) return;
        const option = select.selectedOptions[0];
        root.querySelectorAll('[data-package-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.packageVariant === select.value)));
        root.querySelectorAll('[data-bundle-only]').forEach(el => el.hidden = option.dataset.planners !== 'true');
        const summary = root.querySelector('[data-package-summary]');
        if (summary) summary.textContent = option.textContent.trim();
        const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState(null, '', url);
      };
      root.querySelectorAll('[data-package-variant]').forEach(button => listen(button, 'click', () => {
        if (!select) return;
        select.value = button.dataset.packageVariant;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      if (select) root.classList.add('pm-package-enhanced');
      listen(select, 'change', () => {
        syncPackage();
        const option = select.selectedOptions[0];
        const cents = Number(option.dataset.cents);
        const compare = Number(option.dataset.compare);
        const available = option.dataset.available === 'true';
        root.querySelectorAll('[data-price]').forEach(el => el.textContent = format(cents));
        root.querySelectorAll('[data-pack-price]').forEach(el => el.textContent = format(cents * Number(el.dataset.packPrice)));
        const compareEl = root.querySelector('[data-compare]');
        compareEl.hidden = compare <= cents;
        compareEl.textContent = format(compare);
        const saving = root.querySelector('[data-saving]');
        saving.hidden = compare <= cents;
        saving.textContent = '%' + Math.round((compare - cents) / compare * 100) + ' ' + labels.saving;
        root.querySelectorAll('[data-add]').forEach(button => { button.disabled = !available; button.querySelector('span').textContent = available ? labels.add : labels.unavailable; });
      });
      const form = quantity.closest('form');
      let submitting = false;
      listen(form, 'submit', async event => {
        event.preventDefault();
        if (submitting) return;
        submitting = true;
        setQuantity(quantity.value);
        const buttons = root.querySelectorAll('[data-add]');
        const error = root.querySelector('[data-checkout-error]');
        error.hidden = true;
        const body = new FormData(form);
        buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.querySelector('span').textContent = 'Ödemeye geçiliyor…'; });
        try {
          const base = window.Shopify?.routes?.root || '/';
          const response = await fetch(base + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Ürün eklenemedi. Lütfen tekrar deneyin.');
          window.location.assign(base + 'checkout');
        } catch (failure) {
          error.textContent = failure.message || 'Bağlantı kurulamadı. Lütfen tekrar deneyin.';
          error.hidden = false;
          submitting = false;
          buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); button.querySelector('span').textContent = labels.add; });
        }
      });
      syncPackage();
      setQuantity(quantity.value);
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('pomodoro-controller-v2', PomodoroControllerV2);
  const init = () => document.querySelectorAll('[data-pomodoro]').forEach(root => {
    if (!root.querySelector('pomodoro-controller-v2')) root.append(document.createElement('pomodoro-controller-v2'));
  });
  init();
  document.addEventListener('shopify:section:load', init);
}

if (!window.pomodoroReviewListeners) {
  window.pomodoroReviewListeners = true;
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-review-open]');
    if (opener) document.getElementById(opener.dataset.reviewOpen)?.showModal();
    const closer = event.target.closest('[data-review-close]');
    if (closer) closer.closest('dialog').close();
  });
}

if (!window.pmPlannerPreviewBound) {
  window.pmPlannerPreviewBound = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-planner-zoom]');
    if (link) {
      const dialog = link.closest('.pm-planner-section').querySelector('dialog');
      if (!dialog || !dialog.showModal) return;
      event.preventDefault();
      const img = document.createElement('img'); img.src = link.href; img.alt = link.querySelector('img').alt;
      dialog.querySelector('[data-planner-image]').replaceChildren(img); dialog.showModal();
    }
    const closer = event.target.closest('[data-planner-close]'); if (closer) closer.closest('dialog').close();
    if (event.target.matches('.pm-planner-dialog')) event.target.close();
  });
}
